export default "__VITE_ASSET__BqhIAlOM__"